const ADMIN_WEB_ACESSO = new Set(['TOTAL', 'TOTAL2', 'ADM']);

export default function isAdminFuncionario(funcionario) {
  const permissao = String(funcionario?.permissao || '')
    .trim()
    .toUpperCase();
  return ADMIN_WEB_ACESSO.has(permissao);
}
